import Immutable from 'immutable';

// constants
import { SEND_RECOMMEND_OFFICE_EMAIL } from '../constants/recommendOfficeType';

export default function(state = Immutable.Map(), action) {
  switch (action.type) {
    case SEND_RECOMMEND_OFFICE_EMAIL: return state;
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/recommendOffice.js